import { resolveImagePath } from '@/utils/imageResolver';

export function Hero() {
  const heroImage = resolveImagePath('/images/Air-Haven-Logo1.gif');
  const footerImage = resolveImagePath('/images/Air-Haven-Footer1.jpg');

  return (
    <section className="bg-white py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Hero Banner Image */}
        <div className="mb-8 text-center">
          <img 
            src={heroImage}
            alt="AirHaven Lenhardt Airpark - Live your dream"
            className="mx-auto max-w-full h-auto"
          />
        </div>

        {/* Main Content */}
        <div className="prose max-w-none text-gray-800 leading-relaxed">
          <p className="mb-6 text-base">
            Airhaven at Lenhardt Airpark is a privately owned, public use airport with a 3200 foot paved runway 
            and parallel grass strip in the heart of the lush Oregon Willamette Valley. The airport sits in a gently 
            rolling countryside 25 miles South of Portland, Oregon and nurseries in a beautiful rural 
            community called "Whiskey Hill". It is located 25 nautical miles south of Portland International 
            Airport (PDX) and 27 miles north of the Salem airport (SLE). Airhaven is only 15 minutes driving time 
            from three nearby Interstate 5 exits. Area towns include Hubbard, Aurora, Canby and Woodburn. Fuel 
            shop services are available.
          </p>

          <p className="mb-6 text-base">
            More than seventy condominium-type hangars have been developed for lifetime-lease over the last 
            several years. The hangars and the airport grounds are leased by these hangar owners on a 270 
            year term. Hangars are occasionally available to rent at $325 to $425 per month. Although Airhaven 
            is a general aviation facility, it is programmed to attract vintage, antique, experimental and warbird aircraft. 
            A pilot hangar talk get together is held every Friday at 9:00 A.M. with coffee and doughnuts provided. 
            All who love aviation are welcome to fly or drive in year around. Group breakfast and lunch fly-outs 
            are frequent, especially on Saturdays. Fuel is available 24/7 to members.
          </p>

          <p className="mb-6 text-base">
            Although grass-strip type flying is our specialty, an IFR clearance can be obtained on the ground 
            from Portland Approach on 119.95 and a release from 126.0. An IFR approach into Aurora Airport 
            (UAO) can usually bring an aircraft to VFR conditions for a 3 mile transit to Lenhardt's at pattern 
            altitude. So, we keep it low too! We have services available for your flight planning and convenience.
          </p>

          <p className="mb-8 text-base">
            The airpark is the home of many classic, early military, home built and antique-type aircraft and is 
            programmed to keep the country atmosphere of the early days with the Cascade Mountain view and 
            grass taxiways which invite the tail-draggers to "Come on in, the grass is fine!".
          </p>
        </div>

        {/* Footer Image */}
        <div className="text-center">
          <img 
            src={footerImage}
            alt="Air Haven Airpark aerial view"
            className="mx-auto max-w-full h-auto rounded shadow-md"
          />
        </div>
      </div>
    </section>
  );
}